import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { Analytics } from '@vercel/analytics/react';
import PrivacyPolicy from './components/PrivacyPolicy';
import Home from './components/Home';

// Optional: If you want to see what SignUp is exporting
// import SignUp from './components/SignUp';
// console.log('SignUp debugging =>', SignUp);

// Initialize Google Analytics
ReactGA.initialize('G-6EXX93QKNQ');

function App() {
  return (
    <Router>
      <div className="container">
        <Routes>
          {/* Root route (no auto scroll) */}
          <Route path="/" element={<Home />} />

          {/* If user visits /rates => auto scroll to the rates table */}
          <Route path="/rates" element={<Home scrollTo="rates" />} />

          {/* If user visits /signup => auto scroll to the sign-up section */}
          <Route path="/signup" element={<Home scrollTo="signup" />} />

          {/* If user visits /faq => auto scroll to the FAQ section */}
          <Route path="/faq" element={<Home scrollTo="faq" />} />

          {/* Privacy policy route */}
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />

          {/* Fallback / 404 */}
          <Route path="*" element={<div>404 - Page Not Found</div>} />
        </Routes>
        <Analytics mode="production" />
      </div>
    </Router>
  );
}

export default App;
